export default __webpack_public_path__ + "d8679a0b727321302de359f9c9febd62.svg";